import { alpha } from '@mui/material/styles';

import { marca } from './cores.primitivas';

/** Raio de canto e elevação. Poucos valores de propósito. */
export const raio = {
  /** Selo, chip, campo. */
  pequeno: 4,
  /** Cartão, diálogo. */
  medio: 8,
  /** Avatar e indicador redondo. */
  circulo: '50%',
} as const;

/**
 * Sombra. Uma só, e fraca. Ferramenta de fila vive de borda e de cor de
 * estado; sombra empilhada vira ruído e come contraste percebido.
 *
 * Derivada da primária com `alpha()` em vez de um `rgba(11, 45, 114, ...)`
 * escrito à mão: cor duplicada em decimal é a mesma dívida do hex solto,
 * só que invisível para o teste que procura `#`.
 */
export const sombra = {
  cartao: `0 1px 2px ${alpha(marca.primaria, 0.06)}, 0 1px 3px ${alpha(marca.primaria, 0.08)}`,
  sobreposicao: `0 8px 24px ${alpha(marca.primaria, 0.16)}`,
} as const;

/** Espessura do anel de foco. `outline: none` é proibido no tema. */
export const espessuraDoFoco = 2;
